export const Constants = {
  ALL_COUPONS: "All Coupons",
  ALL_PRODUCTS: "All Products",
}